import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignItemConfig,
  ReportDesignItemSelectbox
} from "../../report-design-item";

@Pipe({
  name: "asSelectboxConfig",
  standalone: false
})
export class ReportItemConfigAsSelectboxPipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignItemSelectbox {
    return <ReportDesignItemSelectbox>value;
  }
}
